var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.514.041a2.748 2.748 0 0 0-.41.016l-7.21 1.125c-.813.082-.901.462-.894.935v9.52c-.413-.272-.856-.465-1.445-.465-.76 0-1.213.29-1.487.674-.274.383-.365.865-.365 1.238 0 .45.155.93.488 1.295.334.366.846.623 1.582.623.832 0 1.416-.232 1.747-.686.26-.357.405-.835.457-1.423.007-.072.01-.146.015-.221.004-.06.003-.102.004-.172H6V4.797c.022-.62.584-.711.584-.711l5.854-.914c.561-.172.562.523.562.523v6.942c-.413-.272-.856-.465-1.445-.465-.76 0-1.213.29-1.487.674-.274.383-.365.865-.365 1.238 0 .45.155.93.488 1.295.334.366.846.623 1.582.623.832 0 1.416-.232 1.747-.686.26-.357.405-.835.457-1.423.007-.072.01-.146.015-.221.004-.06.003-.102.004-.172H14V.932c.012-.686-.14-.867-.486-.891z",
    fill: "#bfbfbf",
    fillRule: "evenodd",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none"
    },
    "white-space": "normal"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.1ad272542fa6da2af8dda813df2a39b4.svg";
export { ForwardRef as ReactComponent };